export default __webpack_public_path__ + "static/media/Jason-Huang-Kung.3036b62c.png";